const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const getAddressOptions = (addresses = []) => {
  const normalizedAddresses = addresses.map((item, index) => {
    const address = item.address || item;
    const line1 = address.line1 || '';
    const city = address.city || address.district_or_city || '';
    const label = [line1, city].filter(Boolean).join(', ');

    return {
      label,
      value: `address_${index}`,
      address,
    };
  });

  const hasNewAddress = normalizedAddresses.some(({value}) => value === 'new_address');

  if (!hasNewAddress) {
    normalizedAddresses.push({
      label: 'Add New Address',
      value: 'new_address',
      address: null,
    });
  }

  return normalizedAddresses;
};

const injectAddressFieldsIntoSchema = (schema, addressOptions, config = {}) => {
  const {
    selectorField = 'addressSelector',
    defaultValue = 'new_address',
    targetFieldPrefix = '',
  } = config;

  const selectorIndex = schema && schema.fields.findIndex((field) => field.name === selectorField);
  if (selectorIndex === -1) return schema;

  const selectorFieldData = schema.fields[selectorIndex];

  // Set options and default value
  selectorFieldData.meta.options = addressOptions.map(({label, value}) => {
    return {label, value};
  });
  selectorFieldData.meta.value = defaultValue;

  // Build events for setting values
  const changeEvents = [];

  const fieldsToUpdate = [
    {ref: `${targetFieldPrefix}line1`, sourceKey: 'line1'},
    {ref: `${targetFieldPrefix}line2`, sourceKey: 'line2'},
    {ref: `${targetFieldPrefix}line3`, sourceKey: 'line3'},
    {ref: `${targetFieldPrefix}pincode`, sourceKey: 'pincode'},
    {ref: `${targetFieldPrefix}district_or_city`, sourceKey: 'city'},
    {ref: `${targetFieldPrefix}country`, sourceKey: 'country'},
  ];

  const targetFieldNames = fieldsToUpdate.map((f) => f.ref);

  schema.fields.forEach((field) => {
    if (targetFieldNames.includes(field.name)) {
      if (field.meta && field.meta.dependencies) {
        if (
          field.meta.dependencies.exists &&
          field.meta.dependencies.exists.ref === selectorField
        ) {
          delete field.meta.dependencies;
        }
      }
    }
  });

  fieldsToUpdate.forEach(({ref, sourceKey}) => {
    const valueMap = {};
    addressOptions.forEach((option) => {
      if (option.value === 'new_address') {
        valueMap[option.value] = '';
      } else if (option.address) {
        let val = option.address[sourceKey];
        if (sourceKey === 'city' && !val) {
          val = option.address.district_or_city;
        }
        valueMap[option.value] = val || '';
      }
    });

    changeEvents.push({
      type: 'setter',
      ref,
      valueMap,
    });
  });

  selectorFieldData.meta.events = {
    ...(selectorFieldData.meta.events || {}),
    change: changeEvents,
  };

  return schema;
};

export {getAddressOptions, injectAddressFieldsIntoSchema};
